import * as React from 'react';
import { Form, Message } from 'semantic-ui-react';

import Panel from 'src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Panel';
import capitalizar from 'src/modulos/Matriculas/IngresoNuevaMatricula/utils/capitalizar';
import CorreosElectronicos, {
    Datos as CorreosElectronicosDatos,
    inicial as correosElectronicosInicial,
} from '../../../../CorreosElectronicos';
import RelacionConAlumno, {
    Datos as RelacionConAlumnoDatos,
    inicial as relacionConAlumnoInicial,
} from '../../../../RelacionConAlumno';
import Telefonos, {
    Datos as TelefonosDatos,
    inicial as telefonosInicial,
} from '../../../../Telefonos';

export interface Datos {
    nombreCompleto: string;
    relacionConAlumno: RelacionConAlumnoDatos;
    telefonos: TelefonosDatos;
    correos: CorreosElectronicosDatos;
}

export const inicial: Datos = {
    nombreCompleto: '',
    relacionConAlumno: { ...relacionConAlumnoInicial, id: 'Otro', otro: '' },
    telefonos: { ...telefonosInicial },
    correos: { ...correosElectronicosInicial },
};

interface Props {
    contacto: Datos;
    onChange(contacto: Datos): void;
}

class ContactoEmergencia extends React.PureComponent<Props> {
    public render() {
        const { contacto, onChange } = this.props;

        return (
            <Panel titulo='Contacto de emergencia'>
                <Message size='large' info visible>
                    Esta persona debe ser distinta al apoderado.
                </Message>

                <Form.Input
                    label='Nombre completo'
                    placeholder='Manuel Sánchez Bernal'
                    required
                    value={contacto.nombreCompleto}
                    onChange={(_e, { value }) => {
                        onChange({
                            ...contacto,
                            nombreCompleto: capitalizar(value),
                        });
                    }}
                />

                <RelacionConAlumno
                    relacionConAlumno={contacto.relacionConAlumno}
                    onChange={relacionConAlumno => {
                        onChange({ ...contacto, relacionConAlumno });
                    }}
                />

                <Telefonos
                    requeridos
                    telefonos={contacto.telefonos}
                    onChange={telefonos => {
                        onChange({ ...contacto, telefonos });
                    }}
                />

                <CorreosElectronicos
                    requeridos={false}
                    correos={contacto.correos}
                    onChange={correos => {
                        onChange({ ...contacto, correos });
                    }}
                />
            </Panel>
        );
    }
}

export default ContactoEmergencia;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S3Alumnos/componentes/Alumno/componentes/ContactoEmergencia.tsx